import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEO from '@/components/feature/SEO';
import { aboutInfo, statsData } from '@/mocks/articles';

export default function AboutPage() {
  const aboutSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '51吃瓜黑料网',
    url: 'http://moonr.cn/',
    description: '51吃瓜黑料网是国内领先的娱乐八卦资讯平台，专注网曝门事件、网红猛料、每日大赛等热门内容。',
    foundingDate: '2018',
    contactPoint: {
      '@type': 'ContactPoint',
      telephone: aboutInfo.cooperation.phone,
      email: aboutInfo.cooperation.email,
      contactType: 'customer service',
    },
    address: {
      '@type': 'PostalAddress',
      streetAddress: '北京市朝阳区互联网大街888号吃瓜大厦18层',
      addressLocality: '北京',
      addressCountry: 'CN',
    },
  };

  return (
    <>
      <SEO
        title="关于我们 | 51吃瓜黑料网 - 品牌介绍、口碑评价与合作联系"
        description="了解51吃瓜黑料网的品牌故事、平台数据、商务合作联系方式及常见问题。51吃瓜黑料网站🔥承接网曝门与在线爆料搜索需求，网红猛料实时追踪不停更。"
        keywords="51吃瓜黑料网, 关于我们, 品牌介绍, 商务合作, 联系我们, 吃瓜, 黑料"
        ogTitle="关于我们 | 51吃瓜黑料网"
        ogDescription="了解51吃瓜黑料网的品牌故事、平台数据与商务合作联系方式。"
        ogImage="https://readdy.ai/api/search-image?query=Abstract%20modern%20corporate%20about%20us%20page%20banner%2C%20warm%20coral%20and%20amber%20gradient%20background%2C%20stylized%20team%20illustration%2C%20editorial%20clean%20design%2C%20minimalist%20composition%20with%20soft%20geometric%20elements%2C%20professional%20warm%20atmosphere%2C%20no%20text%2C%20pure%20abstract%20visual&width=1200&height=630&seq=og-about-51chigua&orientation=landscape"
        schema={aboutSchema}
      />
      <Navbar />

      <main className="pt-16">
        {/* Breadcrumb */}
        <div className="px-4 md:px-6 py-6 bg-background-50">
          <nav className="flex items-center gap-2 text-sm text-foreground-400" aria-label="面包屑导航">
            <Link to="/" className="hover:text-primary-500 transition-colors whitespace-nowrap">首页</Link>
            <i className="ri-arrow-right-s-line"></i>
            <span className="text-foreground-700 font-medium">关于我们</span>
          </nav>
        </div>

        {/* Hero Banner */}
        <section className="relative w-full h-[300px] md:h-[400px] overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=Abstract%20modern%20corporate%20about%20us%20hero%20banner%2C%20warm%20coral%20and%20amber%20gradient%20tones%2C%20stylized%20abstract%20geometric%20shapes%20floating%20in%20harmonious%20composition%2C%20soft%20warm%20lighting%2C%20clean%20minimalist%20editorial%20aesthetic%2C%20professional%20yet%20approachable%20atmosphere%2C%20subtle%20grid%20texture%20overlay%2C%20no%20text%20or%20words%2C%20pure%20artistic%20abstract%20visual&width=1920&height=800&seq=about-hero-51chigua&orientation=landscape"
            alt="关于51吃瓜黑料网"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/15 to-black/40"></div>
          <div className="absolute inset-0 flex items-center justify-center">
            <div className="text-center px-4">
              <h1 className="font-heading text-3xl md:text-5xl text-background-50">关于我们</h1>
              <p className="mt-3 text-sm md:text-lg text-background-50/70 max-w-xl mx-auto">
                {aboutInfo.slogan}
              </p>
            </div>
          </div>
        </section>

        {/* Brand Introduction */}
        <section className="px-4 md:px-6 py-10 md:py-14 bg-background-50">
          <div className="max-w-3xl mx-auto">
            <div className="flex items-center gap-4 mb-8">
              <div className="w-14 h-14 md:w-16 md:h-16 rounded-full bg-primary-50 flex items-center justify-center">
                <i className="ri-fire-line text-2xl text-primary-500"></i>
              </div>
              <div>
                <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">品牌故事</h2>
                <p className="text-sm text-foreground-400 mt-1">自{aboutInfo.foundingYear}年起，专注于每一颗真实的瓜</p>
              </div>
            </div>
            <div className="text-sm md:text-base text-foreground-700 leading-relaxed space-y-4">
              {aboutInfo.intro.split('\n\n').map((paragraph, i) => (
                <p key={i}>{paragraph.trim()}</p>
              ))}
            </div>
          </div>
        </section>

        {/* Milestones */}
        <section className="px-4 md:px-6 py-10 md:py-14 bg-background-100">
          <div className="max-w-4xl mx-auto">
            <div className="text-center mb-10">
              <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">发展历程</h2>
              <p className="mt-2 text-sm text-foreground-500">从零到两千万用户，每一步都算数</p>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
              {aboutInfo.milestones.map((milestone) => (
                <div
                  key={milestone.year}
                  className="p-5 rounded-lg bg-background-50 transition-all duration-300 hover:-translate-y-1"
                >
                  <span className="inline-block px-3 py-1 bg-primary-500 text-background-50 text-xs font-bold rounded-full whitespace-nowrap">
                    {milestone.year}
                  </span>
                  <p className="mt-3 text-sm text-foreground-700 leading-relaxed">{milestone.event}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Platform Stats */}
        <section className="px-4 md:px-6 py-10 md:py-14 bg-background-50">
          <div className="max-w-4xl mx-auto">
            <div className="text-center mb-10">
              <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">平台数据</h2>
              <p className="mt-2 text-sm text-foreground-500">数据见证实力，口碑铸就品牌</p>
            </div>
            <div className="grid grid-cols-2 md:grid-cols-3 gap-4 md:gap-5">
              {aboutInfo.platformData.map((item) => (
                <div
                  key={item.label}
                  className="p-6 rounded-lg bg-background-100 text-center transition-all duration-300 hover:-translate-y-1"
                >
                  <div className="w-12 h-12 mx-auto rounded-full bg-accent-50 flex items-center justify-center">
                    <i className={`${item.icon} text-xl text-accent-500`}></i>
                  </div>
                  <p className="mt-3 text-xl md:text-2xl font-bold text-foreground-950">{item.value}</p>
                  <p className="mt-1 text-xs text-foreground-500">{item.label}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Business Cooperation */}
        <section className="px-4 md:px-6 py-10 md:py-14 bg-background-100">
          <div className="max-w-3xl mx-auto">
            <div className="text-center mb-10">
              <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">商务合作</h2>
              <p className="mt-2 text-sm text-foreground-500">期待与您携手共赢</p>
            </div>
            <p className="text-sm md:text-base text-foreground-700 leading-relaxed text-center max-w-2xl mx-auto mb-8">
              {aboutInfo.cooperation.description}
            </p>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-5">
              <div className="p-5 rounded-lg bg-background-50 flex items-start gap-4">
                <div className="w-10 h-10 rounded-full bg-primary-50 flex items-center justify-center flex-shrink-0">
                  <i className="ri-mail-line text-lg text-primary-500"></i>
                </div>
                <div>
                  <p className="text-xs text-foreground-400 uppercase tracking-wider">合作邮箱</p>
                  <p className="text-sm font-medium text-foreground-800 mt-1">{aboutInfo.cooperation.email}</p>
                </div>
              </div>
              <div className="p-5 rounded-lg bg-background-50 flex items-start gap-4">
                <div className="w-10 h-10 rounded-full bg-accent-50 flex items-center justify-center flex-shrink-0">
                  <i className="ri-phone-line text-lg text-accent-500"></i>
                </div>
                <div>
                  <p className="text-xs text-foreground-400 uppercase tracking-wider">联系电话</p>
                  <p className="text-sm font-medium text-foreground-800 mt-1">{aboutInfo.cooperation.phone}</p>
                </div>
              </div>
              <div className="p-5 rounded-lg bg-background-50 flex items-start gap-4">
                <div className="w-10 h-10 rounded-full bg-secondary-50 flex items-center justify-center flex-shrink-0">
                  <i className="ri-map-pin-line text-lg text-secondary-500"></i>
                </div>
                <div>
                  <p className="text-xs text-foreground-400 uppercase tracking-wider">公司地址</p>
                  <p className="text-sm font-medium text-foreground-800 mt-1">{aboutInfo.cooperation.address}</p>
                </div>
              </div>
              <div className="p-5 rounded-lg bg-background-50 flex items-start gap-4">
                <div className="w-10 h-10 rounded-full bg-primary-50 flex items-center justify-center flex-shrink-0">
                  <i className="ri-wechat-line text-lg text-primary-500"></i>
                </div>
                <div>
                  <p className="text-xs text-foreground-400 uppercase tracking-wider">官方微信</p>
                  <p className="text-sm font-medium text-foreground-800 mt-1">{aboutInfo.cooperation.wechat}</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* FAQ */}
        <section className="px-4 md:px-6 py-10 md:py-14 bg-background-50">
          <div className="max-w-3xl mx-auto">
            <div className="text-center mb-10">
              <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">常见问题</h2>
              <p className="mt-2 text-sm text-foreground-500">你想知道的，都在这里</p>
            </div>
            <div className="flex flex-col gap-4">
              {aboutInfo.faqs.map((faq, index) => (
                <details
                  key={index}
                  className="group rounded-lg bg-background-100 overflow-hidden cursor-pointer"
                >
                  <summary className="flex items-center justify-between p-5 text-sm md:text-base font-bold text-foreground-800 list-none">
                    <span className="pr-4">{faq.q}</span>
                    <span className="flex-shrink-0 w-6 h-6 rounded-full bg-background-200 flex items-center justify-center group-open:rotate-45 transition-transform duration-200">
                      <i className="ri-add-line text-sm text-foreground-500"></i>
                    </span>
                  </summary>
                  <div className="px-5 pb-5">
                    <p className="text-sm text-foreground-600 leading-relaxed">{faq.a}</p>
                  </div>
                </details>
              ))}
            </div>
          </div>
        </section>

        {/* CTA */}
        <section className="px-4 md:px-6 py-10 md:py-14 bg-background-100">
          <div className="max-w-2xl mx-auto text-center">
            <h2 className="font-heading text-xl md:text-2xl text-foreground-950">
              加入我们，成为吃瓜第一梯队
            </h2>
            <p className="mt-3 text-sm text-foreground-500">
              关注51吃瓜黑料网，不错过任何精彩热点
            </p>
            <div className="mt-6 grid grid-cols-2 md:grid-cols-4 gap-4">
              {statsData.map((stat) => (
                <div key={stat.label} className="text-center">
                  <p className="text-xl md:text-2xl font-bold text-primary-500">{stat.value}</p>
                  <p className="text-xs text-foreground-400 mt-1">{stat.label}</p>
                </div>
              ))}
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}